export class AlicuotaDiferencial{
    id: string;
    alicuota: number;
    fechaDesde: string;
    fechaHasta: string;
}